<div class="mentor_guide_wrap" *ngIf="!isScorm && isShowItem">
  <div class="guide_target" (click)="clickMenu()">
    <div class="guide_menu_clone">
      <span class="menu-line"></span>
      <span class="menu-line"></span>
      <span class="menu-line"></span>
      <span class="menu-red-dot"></span>
    </div>
    <!-- <span class="guide_click_ring"></span> -->
  </div>
  <div class="guide_hand"></div>
  <div class="guide_tip_box">
    <span class="guide_arrow"></span>
    <div class="guide_tip_content">
      <p class="guide_title">我的导师，上线啦～</p>
      <p class="guide_desc">DDI最新发布AI领导力导师，拥有丰富的领导力经验和学习资源，快来体验吧～</p>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-mentor-guide/app-mentor-guide.component.html